import { render, staticRenderFns } from "./FeedApplications.vue?vue&type=template&id=2621d77d&scoped=true"
import script from "./FeedApplications.vue?vue&type=script&lang=js"
export * from "./FeedApplications.vue?vue&type=script&lang=js"
import style0 from "./FeedApplications.vue?vue&type=style&index=0&id=2621d77d&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2621d77d",
  null
  
)

export default component.exports